<template>
  <div id="topology-map" class="topology-map">
    <img v-if="loading || showNoData" src="/static/img/common/no-data.png">
    <p v-if="loading" class="empty-description">加载中...</p>
    <p v-if="showNoData && !loading" class="empty-description">暂无画面</p>
  </div>
</template>

<script type="text/ecmascript-6">
import TopologyMap from './TopologyMap.js'
export default TopologyMap
</script>

<style lang="scss">
@import "TopologyMap";
</style>



// WEBPACK FOOTER //
// src/components/topologyMap/TopologyMap.vue